module.exports = __webpack_public_path__ + "img/gsjj.4f8e9824.png";